import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';

gsap.registerPlugin( ScrollTrigger, CustomEase );

( function( app ) {
  const COMPONENT = {
    animate: function() {
      if ( window.matchMedia( '(prefers-reduced-motion)' ).matches ) {
        return;
      }

      const animateEl = ( el ) => {
        const $el = $( el );

        const children = $el.children().length ? $el.children() : $el;

        children.each( function( index, child ) {
          const fadeDelay = index * 0.12;

          gsap.fromTo(
              child,
              {
                opacity: 0,
                y: 25,
              },
              {
                opacity: 1,
                y: 0,
                duration: 0.6,
                ease: 'power2.out',
                delay: fadeDelay,
              },
          );

          const scaleEl = child.querySelector?.( '.js-scale' );

          if ( scaleEl ) {
            const scaleDelay = fadeDelay + 0.35;

            gsap.fromTo(
                scaleEl,
                {
                  scale: 0,
                },
                {
                  scale: 1.1,
                  duration: 0.45,
                  ease: 'back.out(2)',
                  delay: scaleDelay,

                  onComplete: () => {
                    gsap.to( scaleEl, {
                      scale: 1,
                      duration: 0.2,
                      ease: 'power2.out',
                    } );
                  },
                },
            );
          }
        } );

        $el.addClass( 'js-animated' );
      };

      $( `
        .js-fade:not(.js-ignore),
        .js-reveal:not(.js-ignore),
        .js-fade-group,
        .js-fade.fade-on-load:not(.js-ignore),
        .js-reveal.fade-on-load:not(.js-ignore),
        .js-fade-group.fade-on-load
      ` ).each( function() {
        ScrollTrigger.create( {
          trigger: this,
          start: $( this ).hasClass( 'fade-on-load' ) ?
              'top 100%' :
              'top 85%',

          once: true,

          onEnter: () => animateEl( this ),

          onRefresh: ( self ) => {
            if ( self.progress > 0 ) {
              $( this ).addClass( 'js-animated' );
            }
          },
        } );
      } );
    },

    onError: function() {
      document.querySelectorAll(
          '.js-fade, .js-reveal, .js-fade-group',
      )?.forEach( ( el ) => {
        el.classList.remove(
            'js-fade',
            'js-reveal',
            'js-fade-group',
        );

        el.classList.add( 'js-animated' );
      } );
    },
  };

  app.registerComponent( 'animations', COMPONENT );
} )( app );
